import React from 'react';
import cx from 'classnames';
import { SLDSInput } from '@salesforce/design-system-react';

function Input({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSInput, Object.assign({}, props, {
    className: cx(className, "tds-form-element_input")
  }));
}
Input.displayName = "Input";
Input.propTypes = SLDSInput.propTypes;
Input.defaultProps = SLDSInput.defaultProps;

export { Input as default };
